<template>
  <v-dialog v-model="show" persistent max-width="420px">
    <v-card>
      <v-toolbar dark color="primary" dense>
        <v-btn icon dark @click="cancelar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Ausencia de Turno Fijo</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pt-4">
        <v-select
          v-model="motivo"
          :items="motivos"
          label="Motivo de la baja *"
          prepend-icon="mdi-clipboard-text"
          dense
          outlined
          :rules="[(v) => !!v || 'Seleccione un motivo']"
        ></v-select>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="grey" @click="cancelar">Cancelar</v-btn>
        <v-btn color="error" :disabled="!motivo" @click="confirmar">
          Confirmar Baja
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    visible: { type: Boolean, required: true },
  },
  data() {
    return {
      motivo: null,
      motivos: [
        "Fuerza Mayor",
        "Incumplimiento del Jugador",
        "No Jugado pero abonado",
      ],
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) this.$emit("close");
      },
    },
  },
  methods: {
    confirmar() {
      this.$emit("confirmar", this.motivo);
      this.motivo = null;
    },
    cancelar() {
      this.motivo = null;
      this.$emit("close");
    },
  },
};
</script>
